export default __webpack_public_path__ + "static/media/rotary-die.65f668f6.png";